import React from "react";
import { SO_STATUS, SO_STOCK } from "@/lib/sales";

export function OrderStatusBadge({ status, testid }) {
  const s = SO_STATUS[status] || SO_STATUS.draft;
  return <span data-testid={testid} className={`inline-block px-2 py-0.5 rounded-md border text-[11px] font-semibold ${s.cls}`}>{s.label}</span>;
}

export function StockStatusBadge({ status, shortage, testid }) {
  if (!status) return <span className="text-slate-400 text-xs" data-testid={testid}>—</span>;
  const s = SO_STOCK[status];
  return (
    <span className="inline-flex items-center gap-1.5 text-xs font-medium text-slate-700" data-testid={testid}>
      <span className={`w-2.5 h-2.5 rounded-full ${s.dot}`} />{s.label}
      {shortage > 0 && <span className="text-rose-600">({shortage.toLocaleString("tr-TR")} eksik)</span>}
    </span>
  );
}

export function DeliveryStatus({ status }) {
  const map = { partial: "Kısmi", completed: "Teslim Edildi" };
  return <span className="text-xs text-slate-600">{map[status] || (status === "cancelled" ? "—" : "Bekliyor")}</span>;
}
